<template>
  <div class="MultipleQuoteGraphVue ipc-group-box ipc-sector">
    <div class="title-sector">
      <h2>POR SECTORES</h2>
    </div>
    <div>
      <label class="ipc-ms-label">Periodo</label>
      <multiselect
        v-model="selectedPeriod"
        :options="allPeriods"
        select-label="ACTIVAR"
        deselect-label="DESACTIVAR"
        placeholder="Seleccionar periodo"
        @input="changePeriod"
      >
        <template slot="noResult">
          <span v-html="'No se encontraron resultados.'"></span>
        </template>
      </multiselect>
    </div>

    <div>
      <label class="ipc-ms-label">Sectores</label>
      <multiselect
        v-model="selectedSectors"
        :options="allSectors"
        :multiple="true"
        select-label="ACTIVAR"
        deselect-label="DESACTIVAR"
        placeholder="Seleccionar sectores"
        :max="maxOptions"
        @input="changeSectors"
      >
        <template slot="maxElements">
          <span
            v-html="'Máximo puede seleccionar ' + maxOptions + ' opciones.'"
          ></span>
        </template>
        <template slot="noResult">
          <span v-html="'No se encontraron resultados.'"></span>
        </template>
        <template slot="tag" slot-scope="{ option, remove }">
          <span class="multiselect__tag">
            <i
              class="bullet"
              :style="{ color: colors[selectedSectors.indexOf(option)] }"
            ></i>
            <span>{{ option }}</span>
            <i
              aria-hidden="true"
              tabindex="1"
              class="multiselect__tag-icon"
              @click="remove(option)"
            ></i>
          </span>
        </template>
      </multiselect>
    </div>
    <ipc-graph
      :init-dataset="dataset"
      :init-params="params"
      :colors="colors"
    ></ipc-graph>
    <div class="btFuente"><strong>fuente:</strong><span>DANE</span></div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import IpcGraph from "../ipc-graph/IpcGraph.vue";
export default {
  components: { Multiselect, IpcGraph },
  props: {
    allPeriods: Array,
    allSectors: Array,
    dataset: Array,
    city: String,
    period: String,
    sectors: Array,
    hRange: String,
  },
  data() {
    return {
      params: {},
      selectedPeriod: null,
      selectedSectors: null,
      colors: [
        "#0071bc",
        "#39b54a",
        "#f7931e",
        "#ed1c24",
        "#93278f",
        "#ed1e79",
      ],
      maxOptions: 5,
    };
  },
  created() {
    this.selectedPeriod = this.period;
    this.selectedSectors = this.sectors;
    this.params = {
      s: "sector",
      pp: [this.period],
      cc: [this.city],
      ss: this.sectors,
      r: this.hRange,
    };
  },
  methods: {
    changePeriod() {
      this.params.pp = [this.selectedPeriod];
    },
    changeSectors() {
      this.params.ss = this.selectedSectors;
    },
  },
};
</script>
